import { render } from "./EcosystemSection.vue?vue&type=template&id=dabeb524&scoped=true"
import script from "./EcosystemSection.vue?vue&type=script&lang=js"
export * from "./EcosystemSection.vue?vue&type=script&lang=js"

import "./EcosystemSection.vue?vue&type=style&index=0&id=dabeb524&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dabeb524"]])

export default __exports__